import {buildOptions, getEndPoints} from "@/utils/api-call";
import {makeCall} from "@/utils/request";
import * as emConsts from "./constants";
import * as storeUtils from "@/utils/store-handler";
import {EventBus} from "@/event-bus";
import {EVENT_ERROR_TOAST_MESSAGE, EVENT_TOAST_MESSAGE} from "@/store/events";
import consts from "../../../_consts";

export const state = {
  employees: {
    data: [],
    meta: {
      pagination: {
        count: 0,
        current_page: 1,
        per_page: 30,
        total: 0,
        total_pages: 0
      }
    }
  },
  employee: {},
  employeeFileHistory: []
};

export const getters = {
  [emConsts.GETTERS_EMPLOYEE_LIST]: state => {
    return state.employees;
  },
  [emConsts.GETTERS_EMPLOYEE_DETAILS]: state => {
    return state.employee;
  },
  [emConsts.GETTERS_EMPLOYEE_FILE_HISTORY]: state => {
    return state.employeeFileHistory;
  }
};

export const actions = {
  [emConsts.ACTION_GET_EMPLOYEE_LIST]: ({commit}, options) => {
    const employeeListUrl = getEndPoints().employees.getEmployees;
    makeCall(
      employeeListUrl,
      buildOptions("GET", options),
      commit
    ).then(
      response => {
        if (response.data) {
          commit(emConsts.MUTATION_SET_EMPLOYEE_LIST, response);
        }
        if (options.callback) {
          options.callback();
        }
      },
      error => {
        options.errorHandling(storeUtils.handleErrorMessage(error));
        commit(emConsts.MUTATION_SET_EMPLOYEE_LIST, {});
      }
    );
  },
  [emConsts.ACTION_GET_EMPLOYEE_DETAILS]: ({commit}, id) => {
    return new Promise((resolve, reject) => {
      const employeeDetailsUrl = getEndPoints().employees.getEmployee.replace(
        ":id",
        id
      );
      makeCall(
        employeeDetailsUrl,
        buildOptions("GET", {}),
        commit
      ).then(
        response => {
          if (response.data) {
            commit(emConsts.MUTATION_SET_EMPLOYEE_DETAILS, response);
            resolve(response);
          }
        },
        error => {
          reject(error);
        }
      );
    });
  },
  [emConsts.ACTION_GET_EMPLOYEE_FILE_HISTORY]: ({commit}, options) => {
    const employeeFileHistoryUrl = getEndPoints().employees.getEmployeeFileHistory.replace(
      ":id",
      options.id
    );
    makeCall(
      employeeFileHistoryUrl,
      buildOptions("GET", options),
      commit
    ).then(
      response => {
        if (response.data) {
          commit(emConsts.MUTATION_SET_EMPLOYEE_FILE_HISTORY, response);
        }
      }
    );
  },
  [emConsts.ACTION_ADD_TEST_EMPLOYEE]: ({commit}, options) => {
    const addTestEmployeeUrl = getEndPoints().employees.addTestEmployee;
    makeCall(
      addTestEmployeeUrl,
      buildOptions("POST", options.data),
      commit
    ).then(
      response => {
        if (typeof response.error === "object") {
          let error = {message: ""};
          let messages = response.error.message;
          for (let key in messages) {
            if (messages.hasOwnProperty(key)) {
              error.message += "<p>" + messages[key] + "</p>";
            }
          }
          options.errorHandling(error);
        } else if (response.error === "string") {
          // TODO check type of or value
          options.errorHandling(response.error);
        } else if (options.callback) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          options.callback(response);
        }
      },
      error => {
        if (error.response && error.response.data.error) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          options.errorHandling(storeUtils.handleErrorMessage(error));
        }
      }
    );
  },
  [emConsts.ACTION_EDIT_TEST_EMPLOYEE]: ({commit}, options) => {
    const editTestEmployeeUrl = getEndPoints().employees.editTestEmployee.replace(
      ":id",
      options.id
    );
    makeCall(
      editTestEmployeeUrl,
      buildOptions("PUT", options.data),
      commit
    ).then(
      response => {
        if (response.error) {
          options.errorHandling(response.error);
        } else if (options.callback) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          options.callback(response);
        }
      },
      error => {
        if (error.response && error.response.data.error) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          options.errorHandling(storeUtils.handleErrorMessage(error));
        }
      }
    );
  },
  [emConsts.ACTION_TERMINATE_EMPLOYEE]: ({commit}, options) => {
    return new Promise((resolve, reject) => {
      const terminateEmployeeUrl = getEndPoints().employees.terminateEmployee.replace(
        ":id",
        options.id
      );
      makeCall(
        terminateEmployeeUrl,
        buildOptions("PUT", options.data),
        commit
      ).then(
        response => {
          commit(emConsts.MUTATION_TERMINATE_EMPLOYEE, options.id);
          resolve(response);
          EventBus.$emit(EVENT_TOAST_MESSAGE, "Terminate employee successful");
        }
      ).catch(function (response) {
        reject(response);
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          (response.data && response.data.message) || "Something went wrong"
        );
      });
    });
  },
  [emConsts.ACTION_FORCE_DELETE_EMPLOYEE]: ({dispatch, commit}, options) => {
    return new Promise((resolve, reject) => {
      const forceDeleteUrl = getEndPoints().employees.forceDeleteEmployee.replace(
        ":id",
        options.employeeId
      );
      makeCall(
        forceDeleteUrl,
        buildOptions("DELETE", {username: options.username}),
        commit
      ).then(
        () => {
          dispatch(
            emConsts.ACTION_GET_EMPLOYEE_LIST,
            JSON.parse(localStorage.getItem(consts.LOCAL_STORE.pagingOptions))
          );
          EventBus.$emit(
            EVENT_TOAST_MESSAGE,
            "Force delete employee successful"
          );
        }
      ).catch(function (response) {
        reject(response);
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          (response.data && response.data.message) || "Something went wrong"
        );
      });
    });
  }
};

export const mutations = {
  [emConsts.MUTATION_SET_EMPLOYEE_LIST]: (state, employees) => {
    state.employees = employees;
  },
  [emConsts.MUTATION_SET_EMPLOYEE_DETAILS]: (state, employee) => {
    state.employee = employee.data;
  },
  [emConsts.MUTATION_SET_EMPLOYEE_FILE_HISTORY]: (state, employeeFileHistory) => {
    state.employeeFileHistory = employeeFileHistory;
  },
  [emConsts.MUTATION_TERMINATE_EMPLOYEE]: (state, id) => {
    const index = state.employees.findIndex(e => e.id === id);
    state.employees[index].is_terminated = !state.employees[index].is_terminated;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/employees/index.js